// extracted by mini-css-extract-plugin
module.exports = {"mobileSize":"900","link":"ArrowLink-module--link--WBL99","arrow":"ArrowLink-module--arrow--3Z-FB","left":"ArrowLink-module--left--2H7Sv"};